import { Url } from '@42.nl/react-url';

export const CERTIFICATE_CHECK_LOGS_URL = '/certificate-check';

export function toCertificateCheckLogs(): Url {
  return CERTIFICATE_CHECK_LOGS_URL;
}
